/* eslint-disable import/no-cycle */
import { FC, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import dayjs from 'dayjs';
import Typo from '../Typo';
import helpers from '../../utils/helpers';
import styles from './countDownTimer.module.sass';

interface CountDownProps {
  dueDate: string;
  classes: string;
}

const CountDownTimer: FC<CountDownProps> = ({ dueDate, classes }) => {
  const rootCls = clsx(classes);
  const endDate = helpers.date(dueDate);
  const [timerDays, setTimerDays] = useState('00');
  const [timerHours, setTimerHours] = useState('00');
  const [timerMinutes, setTimerMinutes] = useState('00');
  const interval = useRef();

  const startTimer = () => {
    setInterval(() => {
      const now = dayjs();
      const diff = endDate.diff(now, 'milliseconds');

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        .toString()
        .padStart(2, '0');
      const hour = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        .toString()
        .padStart(2, '0');
      const minute = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, '0');

      if (diff < 0) {
        clearInterval(interval.current);
      } else {
        setTimerDays(days);
        setTimerHours(hour);
        setTimerMinutes(minute);
      }
    }, 1000);
  };

  // const [daysLeft, setDaysLeft] = useState(0);

  // useEffect(() => {
  // const current = dayjs().startOf("day");
  // setDaysLeft(endDate.diff(current, "days"));
  // }, [endDate]);

  useEffect(() => {
    // daysLeft > 0 && startTimer();
    startTimer();

    const cleanUp = interval.current;
    return () => {
      clearInterval(cleanUp);
    };
  });

  return (
    <div
      className={`${styles.root} is-flex is-justify-content-space-between has-text-centered ${rootCls}`}
    >
      <div className={`${styles.time} is-flex is-justify-content-space-between has-text-centered`}>
        <div className="mr-2">
          <Typo small>Day</Typo>
          <Typo classes={styles.timeFont}>{timerDays}</Typo>
        </div>
        <div className="mr-2">
          <Typo small>Hour</Typo>
          <Typo classes={styles.timeFont}>{timerHours}</Typo>
        </div>
        <div>
          <Typo small>Minutes</Typo>
          <Typo classes={styles.timeFont}>{timerMinutes}</Typo>
        </div>
      </div>
      <div className={styles.break} />
      <Typo small classes={`is-color-BlackHalf ${styles.remaining}`}>
        Time Remaining
      </Typo>
    </div>
  );
};

export default CountDownTimer;
